import { Link } from 'react-router-dom';

interface CTASectionProps {
  isVisible: boolean;
  sectionRef: React.RefObject<HTMLElement | null>;
  phone: string;
}

export default function CTASection({
  isVisible,
  sectionRef,
  phone
}: CTASectionProps) {
  return (
    <section 
      ref={sectionRef}
      data-section="cta"
      className="py-24 bg-gradient-to-br from-[#2a4b7c] to-[#2a4b7c]/90" 
      id="contact"
    >
      <div className={`max-w-5xl mx-auto px-6 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Sẵn Sàng Chuyển Đổi Số?
        </h2>
        <p className="text-xl text-gray-300 mb-10 leading-relaxed">
          Hãy để chúng tôi đồng hành cùng bạn trên hành trình chuyển đổi số
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/lien-he"
            className="px-10 py-4 bg-[#00c897] text-white text-lg font-semibold rounded-lg hover:bg-[#00b587] transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap hover:scale-105 hover:shadow-xl"
          >
            <i className="ri-calendar-line text-xl"></i>
            Đặt Lịch Tư Vấn
          </Link>
          <a
            href={`tel:${phone.replace(/[^0-9]/g, '')}`}
            className="px-10 py-4 border-2 border-white text-white text-lg font-semibold rounded-lg hover:bg-white hover:text-[#2a4b7c] transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap hover:scale-105"
          >
            <i className="ri-phone-line text-xl"></i>
            Gọi ngay: {phone}
          </a>
        </div>
      </div>
    </section>
  );
}

